<div>
    <img style="width: 200px; opacity: 0.5; margin-bottom: 20px;" src="assets/img/lost.png" />
    <h3>Cliente não encontrado!</h3>
    <h4>Entre em contato com nossa equipe!</h4>
</div>